// ShareButton.js
'use strict';
import { connect } from 'react-redux';

import ShareButton from '../component/ShareButton.jsx';

import pushToastr from '../action/pushToastr.js';
import setClickedShareButton from '../action/setClickedShareButton.js';
import fetchMe from '../action/fetchMe.js';
import fetchUser from '../action/fetchUser.js';

import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import fetchMeReferral from '../action/fetchMeReferral.js';
import { ShareType } from '../hook/useShortShareLink.js';

import getShareLink from '../resource/getShareLink.js';
import { breakpoint } from '../style/variables.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import {
  ANDROID_MINIMUM_VERSION,
  SWAG_ANDROID_PACKAGE_NAME,
} from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { shareType, userId }) => {
  const deviceWidth = getOperationData(state, ['device'], 'width');

  const meId = getMeData(state, 'id');
  const referralCode = getMeData(state, 'referralCode');
  const referralSignupRewardDiamond = getMeData(state, 'rewardReferral');

  const selectPath = ['me', 'referral', meId];
  const isFetching = getNetworkingData(state, selectPath, 'isFetching');
  const isFetched = getNetworkingData(state, selectPath, 'isFetched');
  const shouldFetchReferral = !isFetching && !isFetched;

  const swagAndroidPackageName = getRemoteConfigData(
    state,
    SWAG_ANDROID_PACKAGE_NAME
  );
  const androidMinimunVersion = getRemoteConfigData(
    state,
    ANDROID_MINIMUM_VERSION
  );
  const shareLink =
    shareType === ShareType.LIVESTREAM
      ? getShareLink({
          query: {
            link: typeof window !== 'undefined' ? window?.location?.href : null,
            afl: typeof window !== 'undefined' ? window?.location?.href : null,
            apn: swagAndroidPackageName,
            amv: androidMinimunVersion,
          },
        })
      : getShareLink();

  return {
    shareLink,
    isOnMobile: deviceWidth <= breakpoint.mobile,
    isAutoHandleShareText: true,
    meId,
    userId,
    referralCode,
    referralSignupRewardDiamond,
    shouldFetchReferral,
  };
};

const mapDispatchToProps = (dispatch, { id }) => {
  return {
    pushToastr: data => dispatch(pushToastr(data)),
    setClickedShareButton: ({ clicked }) =>
      dispatch(setClickedShareButton({ messageId: id, clicked })),
    fetchMe: () => dispatch(fetchMe()),
    fetchUser: ({ userId }) => dispatch(fetchUser({ userId })),
    fetchMeReferral: () => dispatch(fetchMeReferral()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareButton);
